"use strict";

Shopify.theme.jsAccounts = {
    init: function init($section) {
        $('.js-create-account').on('click', function (e) {
            e.preventDefault();

            $('#login').hide();
            $('#recover').hide();
            $('#create-account').show();
        });
        $('.js-recover-password').on('click', function (e) {
            e.preventDefault();

            $('#login').hide();
            $('#recover').show();
        });
        $('.cancel-recover-password').on('click', function (e) {
            e.preventDefault();
            $('#create-account').hide();
            $('#recover').hide();
            $('#login').show();
        });

        $('a[href="#account-login-popup"]').on('click', function (e) {
            e.preventDefault();
        });

        let accountLoginPopupAnchor = $('a[data-src="#account-login-popup"]');
        let anchorParent = accountLoginPopupAnchor.parent();
        console.log('accountLoginPopupAnchor.length', accountLoginPopupAnchor.length);
        console.log('anchorParent', anchorParent);

        if (accountLoginPopupAnchor.length > 0) {
            setTimeout(function () {
                let megaMenus = anchorParent.find('section.mega-menu__section.mega-menu__mega-menu-3');
                console.log('megaMenus', megaMenus);

                megaMenus.html('');
            }, 500);
        }

        /* Trigger click event if there's an error when entering email */
        let urlPathName = location.pathname;
        let loginHash = location.hash;
        if (urlPathName.includes('/account/login') && loginHash === '#recover') {
            $('.js-recover-password').trigger('click');
        }
    },
    customAddToWishList: function customAddToWishList(wishlistButton) {
        console.log(wishlistButton.dataset);
    },
    loggedIn: function loggedIn($section) {
        $('.reward-history').click(function (e) {
            $('.mega-menu__section.mega-menu__mega-menu-3').removeClass('is-active');
        });
        $('.share-wishlist').on('click', function (e) {
            e.preventDefault();
            $('#share-form,#all-wishlist h2:last-of-type').show();
          $('.share-wishlist,.my-items,#all-wishlist h2:first-of-type').hide();
        });

        $('.cancel-wishlist-send').on('click', function (e) {
            e.preventDefault();
            $('#share-form,#all-wishlist h2:last-of-type').hide();
	        $('.share-wishlist,.my-items,#all-wishlist h2:first-of-type').show();
        });
        function swymCallbackFn(swat) {
            // your API calls go here
            // use swat within this scope,
            // alternatively you can use window._swat

            let wishlistItems = '';
            let wishlistGrid = $('#all-wishlist .my-items');
            let wishlistNoItems = $('#all-wishlist .no-items');

            /*$('a[href="/account/login"]').click(function (e) {
                e.preventDefault();

                // logout by ending the wishlist session
                swat.disconnectShopperContext();
            });*/

            swat.fetch(function (r) {
                let wishlistCount = r.length;

                if (wishlistCount > 0) {
                    r.forEach(function (v, i) {
                        console.log(v);

                        if (i < 3) {
                            wishlistItems += wishlistImageTemplate(v.du, v.iu, v.dt, v.epi);
                        }

                        Shopify.theme.jsProductJSON.init('wishlist', v.du, v.epi, {
                            wishlistItemInfo: v
                        });
                    });

                    if (wishlistCount > 1) {
                        $('#all-wishlist .item-count span').text(wishlistCount);
                    } else {
                        $('#all-wishlist .item-count').html(`<span>${wishlistCount}</span> item`);
                    }

                    $('#all-wishlist .item-count').show();
                    $('#all-wishlist .share-wishlist').show();
                    $('.wishlist-row').html(wishlistItems);
                    wishlistGrid.show();
                    wishlistNoItems.hide();
                } else {
                    $('.wishlist-row').html('<p>No items in your wishlist.</p>');
                    $('.item-count').hide();
                  	$('#all-wishlist .share-wishlist').hide();
                    wishlistGrid.html('');
                    wishlistGrid.hide();
                    wishlistNoItems.show();
                }

                $('.block__my-wishlist .inner-container .loader-container').fadeOut('slow');

                //console.log(r);
            });

        }

        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymCallbackFn);
        console.log($('input:checked + .swatch-element'));
        setTimeout(function (){
            if(typeof window._swat !== 'undefined'){
                $('input:checked + .swatch-element').trigger('onclick');
            } else {
                setTimeout(function (){
                    if(typeof window._swat !== 'undefined'){
                        $('input:checked + .swatch-element').trigger('onclick');
                    } else {
                        setTimeout(function (){
                            if(typeof window._swat !== 'undefined'){
                                $('input:checked + .swatch-element').trigger('onclick');
                            }
                        },1000);
                    }
                },1000);
            }
        },1000);

        /*let orderDates = document.querySelectorAll('.order-date');
        if (orderDates.length > 0) {
            let rightNow = new Date();
            orderDates.forEach(function (v, i) {
                let textDate = v.innerText;
                let orderDate = new Date(textDate);
                let differenceInTime = rightNow.getTime() - orderDate.getTime();
                let differenceInDays = (differenceInTime / (1000 * 3600 * 24));

                let orderHeaderContainer = v.parentNode.parentNode;
                let orderBodyContainer = orderHeaderContainer.nextElementSibling;

                if (differenceInDays > 90) {
                    let returnItemsColumn = orderBodyContainer.querySelectorAll('.return-items')[0];
                    returnItemsColumn.parentNode.removeChild(returnItemsColumn);
                }
            });
        }*/
    },
    viewOrderItems: function viewOrderItems(viewOrderItemsButton) {
        let orderListContainerID = viewOrderItemsButton.getAttribute("href").replace('#', '');
        let orderListContainer = document.getElementById(orderListContainerID);
        orderListContainer.classList.toggle('show');

        viewOrderItemsButton.preventDefault();
    },
    addToBag: function addToBag(addToBagButton) {
        let tempWrapper = document.createElement('div');
        tempWrapper.innerHTML = getItemLoadingOverlay();
        addToBagButton.appendChild(tempWrapper.firstChild);

        let items = [
            {
                quantity: addToBagButton.dataset['quantity'],
                id: addToBagButton.dataset['id']
            }
        ]

        jQuery.post('/cart/add.js', {
            items: items
        });

        Shopify.theme.jsAjaxCart.updateView();

        setTimeout(function () {
            addToBagButton.innerHTML = 'Add To Bag';
        }, 1000);
    },
    refreshWishlistGrids: function refreshWishlistGrids() {
        window._swat.fetch(function (r) {
            let wishlistCount = r.length;
            let wishlistItems = '';
            let wishlistGrid = $('#all-wishlist .my-items .items-grid');
            let wishlistGridParent = $('#all-wishlist .my-items');
            let wishlistNoItems = $('#all-wishlist .no-items');
            let wishlistItemCountContainer = $('#all-wishlist .item-count');

            if (wishlistCount > 0) {
                wishlistGridParent.html('<div class="items-grid"></div>');

                r.forEach(function (v, i) {
                    console.log(v);

                    if (i < 3) {
                        wishlistItems += wishlistImageTemplate(v.du, v.iu, v.dt, v.epi);
                    }

                    Shopify.theme.jsProductJSON.init('wishlist', v.du, v.epi, {
                        wishlistItemInfo: v
                    });
                });

                if (wishlistCount > 1) {
                    $('#all-wishlist .item-count span').text(wishlistCount);
                } else {
                    wishlistItemCountContainer.html(`<span>${wishlistCount}</span> item`);
                }
                wishlistItemCountContainer.show();
                $('.share-wishlist').show();

                $('.wishlist-row').html(wishlistItems);
                wishlistGridParent.show();
                wishlistNoItems.hide();
            } else {
                $('.wishlist-row').html('<p>No items in your wishlist.</p>');
                $('.share-wishlist').hide();
                wishlistItemCountContainer.hide();
                wishlistGridParent.hide();
                wishlistNoItems.show();
            }

            $('.block__my-wishlist .inner-container .loader-container').hide();
        });
    },
    addWishlistItem: function addWishlistItem(id, image, handle, title, price, color, size, url, wishlistItemInfo) {
        let wishlistItemHTML = wishlistItemPopupTemplate(id, image, handle, title, price, color, size, url, wishlistItemInfo);
        let myItemsGrid = $('.my-items .items-grid');

        myItemsGrid.append(wishlistItemHTML);
        myItemsGrid.show();
    },
    removeWishlistItem: function removeWishlistItem(removeItemElement) {
        let itemContainer = removeItemElement.closest('div.item');
        let preElement = removeItemElement.nextElementSibling;
        let wishlistData = JSON.parse(preElement.innerHTML);

        let args = {
            "epi": wishlistData.epi,
            "du": wishlistData.du,
            "empi": wishlistData.empi,
            "iu": wishlistData.iu,
            "pr": wishlistData.pr
        };

        let tempWrapper = document.createElement('div');
        tempWrapper.innerHTML = getItemLoadingOverlay();
        itemContainer.classList.add('removingItem');
        itemContainer.appendChild(tempWrapper.firstChild);

        window['_swat'].removeFromWishList(args, function (r) {
            itemContainer.parentNode.removeChild(itemContainer);
            Shopify.theme.jsAccounts.refreshWishlistGrids();
        });
    },
    unload: function unload($section) {
        $('.js-recover-password').off();
        $('.cancel-recover-password').off();
    }
};

function showOrderItemOverlay(detailsButton) {
    let showDetails = detailsButton.querySelectorAll('.show-details')[0];
    let hideDetails = detailsButton.querySelectorAll('.hide-details')[0];
    let orderedItemInfo = detailsButton.parentNode;
    let orderedItemContainer = orderedItemInfo.parentNode;
    let orderedItemOverlay = orderedItemContainer.querySelectorAll('.img-container .item-overlay')[0];

    if (showDetails.style.display === "none") {
        showDetails.style.display = "block";
        orderedItemOverlay.style.display = "none";
    } else {
        showDetails.style.display = "none";
        orderedItemOverlay.style.display = "flex";
    }

    if (hideDetails.style.display === "none") {
        hideDetails.style.display = "block";
        orderedItemOverlay.style.display = "flex";
    } else {
        hideDetails.style.display = "none";
        orderedItemOverlay.style.display = "none";
    }
}

function getItemLoadingOverlay() {
    return `<div class="item-loading-overlay">
		<div class="loader"></div>
	</div>`;
}

function wishlistImageTemplate(productLink, productImage, productTitle, variantID) {
    return `<a href="${productLink}?variant=${variantID}" class="wishlist-product column one-third">
			<div class="img-container">
				<img src="${productImage}" alt="${productTitle}">
			</div>
		</a>`;
}
    $(".wishlist-send").click(function(e){
     	var re = new RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$');
      	var first_email  = $('#first_email').val();
       // var second_email  = $('#second_email').val();
      	var fromName = $('#third_input').val();
        var wishlistMessage = $('#wishlist-message').val();

      if(re.test(first_email)){
        	$(".form_input").css("border-color", "#cccccc");
        if(re.test(first_email)){
          $(".form_input").css("border-color", "#cccccc");
        	_swat.sendEmailWishList(function(r) {

              $("#share-form .success").css("display", "block");
              $(".input-wrapper").css("display", "none");
              $(".wishlist-submit").css("display", "none");
              setTimeout(function () {
              $('#share-form,#all-wishlist h2:last-of-type').hide();
	       	  $('.share-wishlist,.my-items,#all-wishlist h2:first-of-type').show();
              }, 2000);
            }, first_email,fromName, wishlistMessage);
        	/*_swat.sendEmailWishList(function(r) {
              $(".success").html('<div>second send success</div>');
            }, second_email,first_email,wishlistMessage);*/
        }else{
        	$(".form_input").css("border-color", "#d42020");
        }
      }else{
      	$(".form_input").css("border-color", "#d42020");
      }

      });
function wishlistItemPopupTemplate(id, image, handle, title, price, color, size, url, wishlistItemInfo) {
    //console.log(wishlistItemInfo);
  console.log('color: ', color)
    let innerDetailsSnippet = '', innerColorSnippet = '', innerSizeSnippet = '';
    let dashedColor = Shopify.theme.slugify(color);
  console.log('color dashed: ', dashedColor)

    if (dashedColor && dashedColor !== "default-title" && dashedColor !== "") {
        innerColorSnippet = `<div class="swatch"><img src="https://cdn.shopify.com/s/files/1/2048/2939/files/${dashedColor}.png" alt="Swatch Color"></div>`;
    }

    if (size) {
        innerSizeSnippet = `<p class="item-size">Size: <span>${size}</span></p>`;
    }

    if (innerColorSnippet !== '' || innerSizeSnippet !== '') {

        innerDetailsSnippet = `<div class="inner-details">${innerColorSnippet}${innerSizeSnippet}</div>`;
    }

    return `<div class="item">
			<div class="img-container">
			  <img src="${image}" alt="${title}">

			  <div class="item-overlay">
				<button class="remove-item" onclick="Shopify.theme.jsAccounts.removeWishlistItem(this)">Remove Item</button>
				<pre style="display: none">${JSON.stringify(wishlistItemInfo)}</pre>
			  </div>
			</div>

			<div class="item-info">
			  <div class="inner-header">
				<small class="item-handle">${handle}</small>
			  </div>

			  <div class="inner-meta">
				<a href="${url}?variant=${id}" class="item-title">${title}</a>
				<p class="item-price">$${price}</p>

				${innerDetailsSnippet}
			  </div>

			  <button class="add-to-bag" data-id="${id}" data-quantity="1" onclick="Shopify.theme.jsAccounts.addToBag(this)">Add to Cart</button>
			</div>
		  </div>`;
}
